import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { DatePicker, } from 'antd';
const { RangePicker } = DatePicker; 
import dayjs from 'dayjs'; 
import { useStoreUpdaterWithAPI } from '../../../Hooks/UseStoreUpdaterWithApi';
import { getAdjustedDate } from '../CommonFunctions';
import { calculateDateRangeFromDate } from '../../../Utils/DateConverstion';

export default function PlantDemand(props) {
    // const data = props.data;
    const theme = props.theme;
    // console.log(data) 
    // console.log(props.theme)
    const [data, setData]= useState( 
      {
        groupName: null,
        minValue: 0,
        maxValue: 0,
        groupAvgDemand: 0
      }
    ); 
    const {makeRequest} = useStoreUpdaterWithAPI();
    const correctDate =  new Date(getAdjustedDate());
  console.log(correctDate)
  // Default start time: Today 6:30 AM, Default end time: Tomorrow 6:30 AM
  const defaultStartTime = dayjs(correctDate).hour(6).minute(30).second(0);
  const defaultEndTime = dayjs(correctDate).add(1, 'day').hour(6).minute(30).second(0);

  const [modalOpen, setModalOpen] = useState(false);
  const [toDate, setToDate] = useState(defaultStartTime);
  const [fromDate, setFromDate] = useState(defaultEndTime); 
  
  const onRangeChange = (dates, dateStrings) => {
    console.log('Date strings:', dateStrings);
    console.log('Dates:', dates);
    if (dates) {
      setToDate(new Date(dateStrings[0]));
      setFromDate(new Date(dateStrings[1]));
    } else {
      console.log('Clear');
    }
  };

  const rangePresets = [
    {
      label: 'Last 7 Days',
      value: [dayjs().add(-7, 'd'), dayjs()],
    },
    {
      label: 'Last 14 Days',
      value: [dayjs().add(-14, 'd'), dayjs()],
    },
    {
      label: 'Last 30 Days',
      value: [dayjs().add(-30, 'd'), dayjs()],
    },
    {
      label: 'Last 90 Days',
      value: [dayjs().add(-90, 'd'), dayjs()],
    },
  ]; 

  const getReposnse =()=>{
    // setLoading(true)
    const currentDate = new Date(); 
  
    const { from, to } = calculateDateRangeFromDate(currentDate, 5, 2);
  
    const inputData = {
      // ConverterID: Number(lgConvId),
      // MeterIds: ids,
      FromDate: from,  
      ToDate:to,
    }; 
    console.log('getReposnse')
    console.log(to, from)   
  
   
    try {      
      makeRequest({
        type: APIConstants.GET,     
    
        //http://20.244.40.160:83/datadetails?FromDate=2024%2F08%2F13%2006%3A30%3A00&ToDate=2024%2F08%2F13%2006%3A30%3A00
        url:`${APIConstants.LUCAS_LIVE_PLNAT_DEMAND_DETAILS}?FromDate=${from}&ToDate=${to}`
        // url:`${APIConstants.LUCAS_LIVE_GAUGE}?FromDate=2024%2F08%2F13%2006%3A30%3A00&ToDate=2024%2F08%2F13%2006%3A30%3A00`
        // token:token, 
        // body:chartInput      
      }).then((res) => {   
        console.log('response' )
        console.log(res)      
        console.log(res[0]) 
        if(res.length > 0 && res[0]){
          setData(res[0]) 
        }
        
  
      });
      // console.log('function  called')     
       
    } catch (error) {
      // setError(true);  
      console.log(error);
    }      
  
  }    

  console.log(data)
  useEffect(() => {
    getReposnse(); // Initial fetch

    const intervalId = setInterval(() => {
      getReposnse();
    }, 60000); 

    return () => clearInterval(intervalId); 
  }, []); 
 
 
    return (
        <div className='text-white  gap-3 flex flex-col flex-grow flex-wrap hover:scale-105 hover:duration-500  w-full lg:w-[350px] shadow-allsides pb-3'>
            <div className='flex gap-3 justify-between p-3 pb-2'>
                <span className={`${theme ==='light' ? "text-slate-600 ":"text-gray-50"}  text-2xl font-bold`}>Plant Demand</span>
            </div>
            <div className='p-2 m-0   flex flex-col justify-center items-center'>
                <div className={`${theme ==='light' ? "text-slate-600 ":"text-gray-50"}  text-sm  underline font-bold `}>Average Value</div>
                <p className='text-xl text-gray-400 font-bold'>{data['groupAvgDemand'] }<span className='text-sm  font-bold'> kVA</span> </p> 
            </div>
            <div className='flex flex-wrap md:flex-nowrap justify-between gap-5  py-1 px-5'>
                <div className={`${theme ==='light' ? "bg-[#c8bfe7]   ":"bg-blue-950 "} p-2 flex-grow hover:scale-105 hover:duration-200 rounded-xl`}> 
                    <p className={` ${theme ==='light' ? "bg-white text-gray-700":"bg-slate-950"} text-base m-0.5 py-3 px-4 rounded-md   text-center font-bold`}>Max Value</p>   
                    <p className={`${theme ==='light' ? "text-slate-700 ":"text-gray-50"}  text-sm text-center m-0  p-4 font-bold `}>{data['maxValue'] + ' kVA' }</p>    
                </div>
                <div className={`${theme ==='light' ? "bg-[#c8bfe7]    ":"bg-blue-950 "}  p-2 flex-grow hover:scale-105  hover:duration-200 rounded-xl`}>
                    <p className={` ${theme ==='light' ? "bg-white text-gray-700":"bg-slate-950"} text-base m-0.5 py-3 px-4 rounded-md  text-center font-bold`}>Min Value</p>
                    <p className={`${theme ==='light' ? "text-slate-700 ":"text-gray-50"}  text-sm text-center m-0  p-4 font-bold `}>{data['maxValue'] + ' kVA' }</p>
                </div>
            </div>
            <div className="flex justify-center items-center w-[90%] m-auto">

                <p className='bg-transparent w-fit p-0 mb-2 text-white  bottom-0' >
              <RangePicker
                    presets={[
                      {
                        label: <span aria-label="Current Time to End of Day">Now ~ EOD</span>,
                        value: () => [dayjs(), dayjs().endOf('day')],
                      },
                      ...rangePresets,
                    ]}
                    showTime
                    format="YYYY/MM/DD HH:mm:ss"
                    defaultValue={[toDate, fromDate]}
                    className={`customRangePicker   ${theme === 'dark' ? 'customRangePicker-dark' : 'customRangePicker-light'}`}
                    onChange={onRangeChange}
                    open={false}
                    disabled={[true, true]}
                  />
                </p>
                    
      </div> 

        </div>
    )
}